/**
 * edit-watchlist-item-request.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { ReplyVerifyingMessage } from "../general/reply-message";
import { MessageTag } from "../message-tag";

export class EditWatchlistItemRequest extends ReplyVerifyingMessage
{
  /** The unique tag for this message type */
  public tag : MessageTag = MessageTag.REQ_EDIT_WATCHLIST_ITEM;
	public static tag : MessageTag = MessageTag.REQ_EDIT_WATCHLIST_ITEM;

  /**
   * Construct a new {@link EditWatchlistItemRequest}.
   */
  constructor (
    public objectId : number,
    public watchId : number,
    public note : string,
    public categories : string[],
    public emailNotifyOnUpdate : boolean
  )
  {
    super();
  }

}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/watchlists/edit-watchlist-item-request.ts